import React from 'react'
import Box from '@mui/material/Box'
import CustomLink from '../../../../../common/CustomLink'

const EmptyCartMessage = () => {
    return <>
        <Box component="h5" style={{marginTop: '5vh'}}>Your cart is empty!</Box>
        <Box component="p">add item to it now!</Box>
        <CustomLink url="/products" label="Shop Now" />
    </>
}

export default EmptyCartMessage;
